import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"20px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-muted mt-2" }

import { computed, onMounted, nextTick, shallowReactive, watch, ref, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import Navigation from '@common/Navigation.vue'
    import ProjectsGrid from '@Quest/Projects/Components/ProjectsGrid.vue'

    import { ProjectsGridViewModel } from '@Quest/Projects/Components/ProjectsGrid'
    import { MyPortfolioProjectsPageReadModel, GridProjectReadModel } from '@Quest/Projects/readmodels'

    import { useMyPortfolioProjectsPageQueryV1 } from '@Quest/Projects/queries-vue-composables'
    import { useSaveViewOwnerProjectsPageCommandV1 } from '@Quest/Portfolios/commands-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MyPortfolioProjectsPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))

    // Query
    const {
        runMyPortfolioProjectsPageQueryV1,
        modelMyPortfolioProjectsPageQueryV1
    } = useMyPortfolioProjectsPageQueryV1(workspaceId, tchProjectId)

    const rm = modelMyPortfolioProjectsPageQueryV1 as Ref<MyPortfolioProjectsPageReadModel | null>
    const projects = computed(() => rm.value?.Projects ?? [])
    const portfolioId = computed(() => rm.value?.PortfolioId ?? '')
    const portfolioName = computed(() => rm.value?.PortfolioName ?? null)
    const isWorkspaceMember = computed(() => rm.value?.IsWorkspaceMember ?? false)

    // Command
    const {
        invokeSaveViewOwnerProjectsPageCommandV1,
        succeedSaveViewOwnerProjectsPageCommandV1
    } = useSaveViewOwnerProjectsPageCommandV1(workspaceId, portfolioId)

    // Stable ViewModel instance
    const grid = shallowReactive(new ProjectsGridViewModel())
    //const selectedIds = ref<string[]>([])


    // Grid handlers
    function handleClearGridFilters()
    {
        grid.clearFilters()
    }

    function handleExportGrid()
    {
        grid.exportGrid()
    }

    function handleShowGridColumnsEditor()
    {
        grid.showGridColumnsEditor()
    }

    function handleSaveViewSettings()
    {
        const gridJson = grid.getJson()

        invokeSaveViewOwnerProjectsPageCommandV1({
            grid: gridJson
        })
    }

    // Query lifecycle
    onMounted(() =>
    {
        document.title = "Project owner | TransparentChoice"
        runMyPortfolioProjectsPageQueryV1()
    })

    // Replace onSetModel logic
    watch(rm, (current, previous) =>
    {
        if (current && !previous)
        {
            nextTick(() =>
            {
                //const getSelectedIds = (e: any) =>
                //{
                //    const selectedRows = e.sender.select()
                //    const ids: string[] = []

                //    for (const r of selectedRows)
                //    {
                //        const dataItem = e.sender.dataItem(r)
                //        ids.push(dataItem[current.Grid.IdField] as string)
                //    }

                //    selectedIds.value = [...new Set(ids)]
                //}

                grid.renderGrid(
                    current.Grid.IdField,
                    current.Grid.Fields,
                    current.Grid.DefaultFieldIds,
                    current.Grid.Options,
                    //getSelectedIds
                )

                grid.setProjects(current.Projects.map(p => p.Properties))
            })
        }
    })

    // Command success watcher
    watch(succeedSaveViewOwnerProjectsPageCommandV1, (current, previous) =>
    {
        if (current && !previous)
        {
            alert("Saved")
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isWorkspaceMember.value)
      ? (_openBlock(), _createBlock(PortfolioNavigation, {
          key: 0,
          workspaceId: workspaceId.value,
          projectId: tchProjectId.value
        }, null, 8 /* PROPS */, ["workspaceId", "projectId"]))
      : (_openBlock(), _createBlock(Navigation, { key: 1 })),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", _hoisted_4, _toDisplayString(portfolioName.value), 1 /* TEXT */),
          _cache[0] || (_cache[0] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "My projects", -1 /* CACHED */))
        ]),
        _createElementVNode("div", { class: "col-lg-6 col-lg-6 text-right align-self-end" }, [
          _createElementVNode("button", {
            role: "button",
            class: "btn btn-outline-secondary",
            style: {"padding":"0.7em 2em"},
            onClick: handleSaveViewSettings
          }, "Save")
        ])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
      _createElementVNode("div", { class: "toolbar" }, [
        _cache[3] || (_cache[3] = _createElementVNode("div", null, [
          _createCommentVNode("<button type=\"button\" class=\"btn btn-outline-secondary\">Action ({{selectedIds.length}})</button>")
        ], -1 /* CACHED */)),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            role: "button",
            class: "btn btn-outline-secondary mr-1",
            onClick: handleShowGridColumnsEditor
          }, "Edit columns"),
          _createElementVNode("div", { class: "btn-group mr-1" }, [
            _cache[1] || (_cache[1] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary dropdown-toggle",
              "data-toggle": "dropdown"
            }, " Actions ", -1 /* CACHED */)),
            _createElementVNode("div", { class: "dropdown-menu dropdown-menu-right" }, [
              _createElementVNode("a", {
                class: "dropdown-item",
                onClick: handleClearGridFilters
              }, "Clear Filters")
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            onClick: handleExportGrid,
            title: "Download to spreadsheet"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "fa fa-download fa-lg" }, null, -1 /* CACHED */)
          ]))])
        ])
      ]),
      _createVNode(ProjectsGrid, { viewModel: _unref(grid) }, null, 8 /* PROPS */, ["viewModel"])
    ])
  ]))
}
}

})